import React, { useState, useEffect, useMemo, useRef } from "react";
import { Table, Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import ExportToExcel from "../../../../../components/ExportToExcel";
import Pagination from "../../../../../components/Pagination";
import SearchBar from "../../../../../components/SearchBar";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import AttendanceBookFilter from "./AttendanceBookFilter";
import { useSelector } from "react-redux";
import { FaSpinner } from "react-icons/fa";
import Select from "react-select";

const AttendanceBookComponent = ({
  data,
  selectedResource,
  selectAllChecked,
  isSubmitStatus,
  columns,
  isSrNoRequired,
  isApiStatus,
  isRequiredStatus,
  searchTerm,
  setSearchTerm,
  handleColumnSelect,
  icons,
  isActionRequired,
  handleReset,
  isCheckBoxRequired,
  isAddNewBtnRequired,
  isFilterRequired,
  isSorting,
  formDatas,
  handleGetData,
  handleAddNew,
  showIcon1,
  showIcon2,
  showIcon3,
  showIcon4,
  showIcon5,
  handleIcon1,
  handleIcon2,
  handleIcon3,
  handleIcon4,
  handleIcon5,
  handleChange,
  filterFormData,
  handleCheckboxChange,
  handleSelectAllChange,
}) => {
  console.log("inside Tabel", isApiStatus);
  const [visibleColumns, setVisibleColumns] = useState(
    Object.keys(columns).reduce((acc, key) => {
      acc[key] = columns[key].visible; // Set initial visibility based on the 'visible' key
      return acc;
    }, {})
  );
  const [editingIndex, setEditingIndex] = useState(null);

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "ascending",
  });

  const ExcelName = useSelector(
    ({ layoutReducer }) => layoutReducer?.filterSlice?.navbarHeading
  );

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  const toggleColumn = (columnName) => {
    setVisibleColumns((prevState) => ({
      ...prevState,
      [columnName]: !prevState[columnName], // Toggle visibility
    }));
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const navigate = useNavigate();

  console.log("data------>", data);

  const sortedData = useMemo(() => {
    if (!Array.isArray(data) || !sortConfig) return data || [];

    const { key, direction } = sortConfig;

    return [...data].sort((a, b) => {
      const valA = a[key] ? String(a[key]) : "";
      const valB = b[key] ? String(b[key]) : "";

      const partsA = valA.match(/(\D+|\d+)/g) || [];
      const partsB = valB.match(/(\D+|\d+)/g) || [];

      for (let i = 0; i < Math.max(partsA.length, partsB.length); i++) {
        const partA = partsA[i] || "";
        const partB = partsB[i] || "";

        const isNumericA = !isNaN(partA);
        const isNumericB = !isNaN(partB);

        if (isNumericA && isNumericB) {
          const numA = Number(partA);
          const numB = Number(partB);
          if (numA !== numB)
            return direction === "ascending" ? numA - numB : numB - numA;
        } else if (isNumericA || isNumericB) {
          return isNumericA ? -1 : 1;
        } else {
          const comparison = partA.localeCompare(partB);
          if (comparison !== 0)
            return direction === "ascending" ? comparison : -comparison;
        }
      }

      return 0;
    });
  }, [data, sortConfig]);

  const filteredData = sortedData.filter((item) =>
    Object.values(item).some((value) =>
      String(value).toLowerCase().includes(searchTerm.toLowerCase())
    )
  );
  console.log("filteredData", filteredData);

  // const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = Math.min(startIndex + itemsPerPage, filteredData.length);
  const currentData = filteredData.slice(startIndex, endIndex);

  const handleSort = (columnName) => {
    let direction = "ascending";
    if (
      sortConfig &&
      sortConfig.key === columnName &&
      sortConfig.direction === "ascending"
    ) {
      direction = "descending";
    }
    setSortConfig({ key: columnName, direction });
  };

  const formatDate = (date) => {
    if (!date) return "-"; // check date is null or undefined

    // Use moment
    const parsedDate = moment(
      date,
      [
        moment.ISO_8601, // Handles ISO date formats
        "DD-MM-YYYY", // Specific format check
        "MM/DD/YYYY", // U.S. format
        "YYYY-MM-DD", // Standard format
        "DD-MMM-YYYY",
        "DD-MM-YY",
      ],
      true
    );

    // Return formatted date if valid, otherwise an empty string
    return parsedDate.isValid() ? parsedDate.format("DD-MMM-YYYY") : "";
  };

  const recordsPerPageOption = [
    { value: 10, label: "10" },
    { value: 25, label: "25" },
    { value: 50, label: "50" },
    { value: 100, label: "100" },
    { value: filteredData.length, label: "All" },
  ];

  const [dropDownValue, setDropdownValue] = useState({});

  const [selectedRecordsPerPage, setSelectedRecordsPerPage] = useState(10);

  const handleRecordsPerPage = (e) => {
    const newRecordsPerPage = Number(e.target.value);

    // Calculate the new starting record index based on the current page
    const currentStartIndex = (currentPage - 1) * selectedRecordsPerPage;
    const newPage = Math.floor(currentStartIndex / newRecordsPerPage) + 1;

    // Update state
    setSelectedRecordsPerPage(newRecordsPerPage);
    setCurrentPage(newPage); // Adjust to the new page based on the same starting record index
    setItemsPerPage(newRecordsPerPage);
  };

  const tdRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (tdRef.current && !tdRef.current.contains(event.target)) {
        setEditingIndex(null); // Reset on outside click
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [editingIndex]);

//   const transformDataForExport = (data) => {
//   // Create mapping of visible column names to their display text
//   const columnHeaders = {};
//   Object.keys(columns).forEach(columnName => {
//     if (visibleColumns[columnName]) {
//       columnHeaders[columnName] = columns[columnName].text;
//     }
//   });

//   return data.map(item => {
//     const transformedItem = {};
    
//     // Process only visible columns
//     Object.keys(columns).forEach(columnName => {
//       if (!visibleColumns[columnName]) return;

//       const columnConfig = columns[columnName];
//       const columnValue = item[columnName];
      
//       // Handle attendance status columns (1 = Present, 0 = Absent)
//       if (columnConfig.option) {
//         const foundOption = columnConfig.option.find(
//           o => o.value === Number(columnValue)
//         );
//         if (foundOption) {
//           transformedItem[columnHeaders[columnName]] = foundOption.label;
//           return;
//         }
//       }
      
//       // Handle other column types
//       if (columnConfig.type === "Select") {
//         transformedItem[columnHeaders[columnName]] = "Select";
//       } 
//       else if (/\b(date|on bench since)\b/i.test(columnConfig.text)) {
//         transformedItem[columnHeaders[columnName]] = formatDate(columnValue);
//       } 
//       else {
//         transformedItem[columnHeaders[columnName]] = columnValue || "";
//       }
//     });
    
//     return transformedItem;
//   });
// };
const transformDataForExport = (data) => {
  // Create mapping of visible column names to their display text
  const columnHeaders = {};
  Object.keys(columns).forEach(columnName => {
    if (visibleColumns[columnName]) {
      columnHeaders[columnName] = columns[columnName].text;
    }
  });

  return data.map(item => {
    const transformedItem = {};
    
    // Process only visible columns
    Object.keys(columns).forEach(columnName => {
      if (!visibleColumns[columnName]) return;

      const columnConfig = columns[columnName];
      const columnValue = item[columnName];
      
      // If value is empty/blank, set as empty string and return
      if (columnValue === null || columnValue === undefined || columnValue === '') {
        transformedItem[columnHeaders[columnName]] = '';
        return;
      }
      
      // Handle attendance status columns (1 = Present, 0 = Absent)
      if (columnConfig.option) {
        const foundOption = columnConfig.option.find(
          o => o.value === Number(columnValue)
        );
        if (foundOption) {
          transformedItem[columnHeaders[columnName]] = foundOption.label;
          return;
        }
      }
      
      // Handle other column types
      if (columnConfig.type === "Select") {
        transformedItem[columnHeaders[columnName]] = "Select";
      } 
      else if (/\b(date|on bench since)\b/i.test(columnConfig.text)) {
        transformedItem[columnHeaders[columnName]] = formatDate(columnValue);
      } 
      else {
        transformedItem[columnHeaders[columnName]] = columnValue || "";
      }
    });
    
    return transformedItem;
  });
};
  return (
    <div className="container-fluid ">
      <div className="d-flex justify-content-between">
        <div className="d-flex">
          <div className="me-1">
            <SearchBar searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
          </div>
          {isFilterRequired && (
            <div className="dropdown">
              <OverlayTrigger
                placement="right"
                overlay={<Tooltip id="tooltip-bottom">Filters</Tooltip>}
              >
                <button
                  className="dropdown-toggle"
                  type="button"
                  id="excel-btn"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <i className="bi bi-funnel-fill"></i>
                </button>
              </OverlayTrigger>

              <div>
                <AttendanceBookFilter
                  formData={formDatas || []}
                  handleChange={handleChange}
                  handleGetData={handleGetData}
                  handleReset={handleReset}
                  filterFormData={filterFormData}
                />
              </div>
            </div>
          )}
        </div>

        <div className="d-flex justify-content-end">
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip id="tooltip-top">Export to Excel</Tooltip>}
          >
            <div className="me-1">
              <ExportToExcel
                data={transformDataForExport(currentData)}
                filename={`${ExcelName}.csv`}
              />
            </div>
          </OverlayTrigger>
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip id="tooltip-top">Column Chooser</Tooltip>}
          >
            <div className="btn-group me-2  position-relative ">
              <button
                type="button"
                className="dropdown-toggle skill-button p-0"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                id="excel-btn"
              >
                <i className="bi bi-list"></i>
              </button>
              <ul
                className="dropdown-menu p-3 "
                style={{
                  overflowY: "auto",
                  maxHeight: "70vh",
                  // border:"none",

                  // minWidth: "250px", // Set minimum width
                  width: "fit-content", // Adjusts width to content
                }}
              >
                <div className="p-0 m-0">
                  <Form.Group>
                    {Object.keys(columns).map((columnName) => (
                      <Form.Check
                        key={columnName}
                        type="checkbox"
                        id={`checkbox-${columnName}`}
                        label={columns[columnName].text} // Display the column name using 'text' key
                        checked={visibleColumns[columnName] || false} // Use 'visible' key to control the checked state
                        onChange={() => toggleColumn(columnName)} // Toggle visibility on change
                      />
                    ))}
                  </Form.Group>
                </div>
              </ul>
            </div>
          </OverlayTrigger>
          {isAddNewBtnRequired && (
            <OverlayTrigger
              placement="bottom"
              overlay={<Tooltip id="tooltip-top">Submit</Tooltip>}
            >
              <button
                id="Add-btn"
                onClick={handleAddNew}
                disabled={isSubmitStatus} // 🔒 disable when loading
              >
                {isSubmitStatus ? <FaSpinner className="sm-spinner" /> : "Submit"}
              </button>
            </OverlayTrigger>
          )}
        </div>
      </div>

      <div className=" ">
        <div className="table-responsive  mb-2">
          <Table striped bordered hover rounded>
            <thead id="thcolor" className="text-center">
              <tr>
                {isCheckBoxRequired && (
                  <th style={{ width: "25px" }}>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      checked={selectAllChecked}
                      onChange={(e) => handleSelectAllChange(e)}
                    />
                  </th>
                )}
                {isSrNoRequired && <th>Sr. No.</th>}
                {Object.keys(columns).map((columnName) => {
                  const isDateColumn = /\b(date|on bench since  )\b/i.test(
                    columns[columnName].text
                  );

                  const columnAlignment = columns[columnName].align || "left";
                  const columnWidth = columns[columnName].width;
                  const isSelectColumn = columns[columnName].type === "Select";
                  const isButtonColumn = columns[columnName].type === "button";
                  const isModalColumn = columns[columnName].type === "Modal";
                  const isImageColumn = columns[columnName].type === "Image";
                  const isLinkColumn = columns[columnName].type === "Link";
                  const hasIcon = columns[columnName].icon;

                  return (
                    visibleColumns[columnName] && (
                      <th
                        style={{
                          whiteSpace: "nowrap",
                          width: columns[columnName].width || "150px",
                        }}
                        key={columnName}
                        onClick={
                          isSorting &&
                            !(isButtonColumn || isModalColumn || hasIcon)
                            ? () => handleSort(columnName)
                            : undefined
                        }
                      >
                        {columns[columnName].text}
                        {isSorting &&
                          !(isButtonColumn || isModalColumn || hasIcon) && (
                            <span className="ms-1">
                              {sortConfig.key === columnName ? (
                                sortConfig.direction === "ascending" ? (
                                  <i className="bi bi-arrow-up"></i>
                                ) : (
                                  <i className="bi bi-arrow-down"></i>
                                )
                              ) : (
                                <i className="bi bi-arrow-down"></i>
                              )}
                            </span>
                          )}
                      </th>
                    )
                  );
                })}
                {isActionRequired && <th>Action</th>}
              </tr>
            </thead>
            {isRequiredStatus ? (
              isApiStatus === 200 && currentData?.length != 0 ? (
                <tbody>
                  {currentData.map((item, index) => (
                    <tr key={index}>
                      {isCheckBoxRequired && (
                        <td>
                          <input
                            className="form-check-input"
                            type="checkbox"
                            checked={
                              !!selectedResource?.find(
                                (o) => o.LineNo === item.LineNo
                              )
                            }
                            onChange={(e) =>
                              handleCheckboxChange(e, item.LineNo, item)
                            }
                          />
                        </td>
                      )}
                      {isSrNoRequired && (
                        <td className="text-center">{index + 1}</td>
                      )}
                      {Object.keys(columns).map((columnName) => {
                        const isDateColumn =
                          /\b(date|on bench since |Purchase Dt |Waranty Dt |Act. DOJ)\b/i.test(
                            columns[columnName].text
                          );

                        const columnAlignment =
                          columns[columnName].align || "left";
                        const columnWidth = columns[columnName].width;

                        const isSelectColumn =
                          columns[columnName].type === "Select";

                        console.log(
                          "columns[columnName].option",
                          columns[columnName].option
                        );

                        return (
                          visibleColumns[columnName] &&
                          (item[columnName] !== undefined ? (
                            <td
                              className={`text-${columnAlignment || "center"
                                } text-truncate`}
                              onClick={() =>
                                setEditingIndex({
                                  row: index,
                                  column: columnName,
                                })
                              } // ✅ Track row and column
                              style={{
                                color:
                                  columns[columnName].option?.find(
                                    (o) => o.value === Number(item[columnName])
                                  )?.color || "inherit",
                                cursor: "pointer",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                            >
                              {isSelectColumn ? (
                                editingIndex?.row === index &&
                                  editingIndex?.column === columnName ? ( // ✅ Check if both row & column match
                                  <Select
                                    name={columnName}
                                    isSearchable={false}
                                    components={{
                                      DropdownIndicator: () => null,
                                      IndicatorSeparator: () => null,
                                    }}
                                    onChange={(selectedOption) => {
                                      handleColumnSelect(selectedOption, item, columnName);
                                      setDropdownValue((prevState) => ({
                                        ...prevState,
                                        [item.LineNo]: {
                                          ...prevState[item.LineNo],
                                          [columnName]: selectedOption,
                                        },
                                      }));
                                      setEditingIndex(null);
                                    }}
                                    menuPortalTarget={document.body}
                                    styles={{
                                      control: (base) => ({
                                        ...base,
                                        height: '26px',
                                        minHeight: '26px',
                                        width: '90px',
                                        fontSize: '12px',
                                      }),
                                      option: (provided) => ({
                                        ...provided,
                                        fontSize: '12px',
                                        padding: '4px 8px',
                                      }),
                                      menu: (base) => ({
                                        ...base,
                                        width: '120px',
                                        marginTop: '2px',
                                      }),
                                      menuPortal: (base) => ({
                                        ...base,
                                        zIndex: 9999,
                                      }),
                                      singleValue: (base) => ({
                                        ...base,
                                        fontSize: '12px',
                                      }),
                                      dropdownIndicator: (base) => ({
                                        ...base,
                                        padding: '4px',
                                      }),
                                    }}
                                    value={
                                      dropDownValue[item.LineNo]?.[columnName] ||
                                      columns[columnName].option?.find(
                                        (o) => o.value === Number(item[columnName])
                                      ) || { value: null, label: "Select" }
                                    }
                                    options={[

                                      ...columns[columnName].option,
                                    ]}
                                    autoFocus
                                    onBlur={() => setEditingIndex(null)}
                                  />
                                ) : item[columnName] != null ? (
                                  columns[columnName].option?.find(
                                    (o) => o.value === Number(item[columnName])
                                  )?.label || "Select"
                                ) : (
                                  ""
                                )
                              ) : (
                                item[columnName] || ""
                              )}
                            </td>
                          ) : null)
                        );
                      })}
                      {isActionRequired && (
                        <td>
                          <div className="d-flex justify-content-center text-center">
                            {showIcon1 && (
                              <OverlayTrigger
                                placement="bottom"
                                overlay={
                                  <Tooltip id="tooltip-bottom">
                                    {icons.Icon1Text || "Edit"}
                                  </Tooltip>
                                }
                              >
                                <div
                                  // className={`me-2 fw-bold disabled-icon${icons?.Icon1Flag && Array.isArray(icons.Icon1Flag) &&
                                  //     icons.Icon1Flag.some(
                                  //       (flag) => item[flag] === 0 || item[flag] === false
                                  //     )
                                  //     ? "disabled-icon"
                                  //     : ""
                                  //   }`}
                                  className=" me-2 fw-bold disabled-icon"
                                  onClick={() => {
                                    if (
                                      false
                                      // !icons?.Icon1Flag ||
                                      // !Array.isArray(icons.Icon1Flag) ||
                                      // !icons.Icon1Flag.some((flag) => item[flag] === 0 || item[flag] === false)
                                    ) {
                                      handleIcon1(item);
                                    }
                                  }}
                                >
                                  {icons.Icon1}
                                </div>
                              </OverlayTrigger>
                            )}

                            {showIcon2 && (
                              <OverlayTrigger
                                placement="bottom"
                                overlay={
                                  <Tooltip id="tooltip-bottom">
                                    {icons.Icon2Text || "Edit"}
                                  </Tooltip>
                                }
                              >
                                <div
                                  // className='me-2'
                                  // onClick={() => handleIcon2(item)}

                                  // className={`me-2 ${
                                  //   item[icons.Icon2Flag] === 0
                                  //     ? "disabled-icon"
                                  //     : ""
                                  // }`}
                                  className={`me-2 ${item[icons.Icon2Flag] === 0 ||
                                      item[icons.Icon2Flag] === false
                                      ? "disabled-icon"
                                      : ""
                                    }`}
                                  // onClick={() => {
                                  //   if (item[icons.Icon2Flag] !== 0)
                                  //     handleIcon2(item);
                                  // }}
                                  onClick={() => {
                                    if (
                                      item[icons.Icon2Flag] !== 0 ||
                                      item[icons.Icon2Flag] !== false
                                    ) {
                                      handleIcon2(item);
                                    }
                                  }}
                                >
                                  {icons.Icon2}
                                </div>
                              </OverlayTrigger>
                            )}
                            {showIcon3 && (
                              <OverlayTrigger
                                placement="bottom"
                                overlay={
                                  <Tooltip id="tooltip-bottom">
                                    {icons.Icon3Text}
                                  </Tooltip>
                                }
                              >
                                <div
                                  className={`me-2 ${item[icons.Icon3Flag] === 0
                                      ? "disabled-icon"
                                      : ""
                                    }`}
                                  onClick={() => {
                                    if (item[icons.Icon3Flag] !== 0)
                                      handleIcon3(item);
                                  }}
                                >
                                  {icons.Icon3}
                                </div>
                              </OverlayTrigger>
                            )}
                            {showIcon4 && (
                              <OverlayTrigger
                                placement="bottom"
                                overlay={
                                  <Tooltip id="tooltip-bottom">
                                    {icons.Icon4Text || "Add"}
                                  </Tooltip>
                                }
                              >
                                <div
                                  className={`me-2 ${item[icons.Icon4Flag] === 0
                                      ? "disabled-icon"
                                      : ""
                                    }`}
                                  onClick={() => {
                                    if (item[icons.Icon4Flag] !== 0)
                                      handleIcon4(item);
                                  }}
                                >
                                  {icons.Icon4}
                                </div>
                              </OverlayTrigger>
                            )}
                            {showIcon5 && (
                              <OverlayTrigger
                                placement="bottom"
                                overlay={
                                  <Tooltip id="tooltip-bottom">
                                    {icons.Icon5Text || "Add"}
                                  </Tooltip>
                                }
                              >
                                <div
                                  className={`me-2 ${item[icons.Icon5Flag] === 0
                                      ? "disabled-icon"
                                      : ""
                                    }`}
                                  onClick={() => {
                                    if (item[icons.Icon5Flag] !== 0)
                                      handleIcon5(item);
                                  }}
                                >
                                  {icons.Icon5}
                                </div>
                              </OverlayTrigger>
                            )}
                          </div>
                        </td>
                      )}
                    </tr>
                  ))}
                </tbody>
              ) : isApiStatus === 200 && currentData?.length === 0 ? (
                <tbody>
                  <tr>
                    <td
                      colSpan={
                        Object.keys(columns).length +
                        (isCheckBoxRequired ? 1 : 0) +
                        (isActionRequired ? 1 : 0)
                      }
                      className="text-center"
                    >
                      <p>No Data Found</p>
                    </td>
                  </tr>
                </tbody>
              ) : isApiStatus === undefined && currentData?.length === 0 ? (
                <tbody>
                  <tr>
                    <td
                      colSpan={
                        Object.keys(columns).length +
                        (isCheckBoxRequired ? 1 : 0) +
                        (isActionRequired ? 1 : 0) +
                        (isSrNoRequired ? 1 : 0)
                      }
                      className="text-center"
                    >
                      <div>
                        <p>
                          <FaSpinner class="spinner" />
                          <br />
                          Loading
                        </p>
                      </div>
                    </td>
                  </tr>
                </tbody>
              ) : (
                // isApiStatus !== 200 && currentData?.length === 0
                <tbody>
                  <tr>
                    <td
                      colSpan={
                        Object.keys(columns).length +
                        (isCheckBoxRequired ? 1 : 0) +
                        (isActionRequired ? 1 : 0)
                      }
                      className="text-center"
                    >
                      <p>No Data Found</p>
                    </td>
                  </tr>
                </tbody>
              )
            ) : currentData?.length != 0 ? (
              <tbody>
                {currentData.map((item, index) => (
                  <tr key={index}>
                    {isCheckBoxRequired && (
                      <td>
                        <input
                          className="form-check-input"
                          type="checkbox"
                          checked={
                            !!selectedResource?.find(
                              (o) => o.EmployeeID === item.EmployeeID
                            )
                          }
                          onChange={(e) =>
                            handleCheckboxChange(e, item.EmployeeID, item)
                          }
                        />
                      </td>
                    )}
                    {isSrNoRequired && (
                      <td className="text-center">{index + 1}</td>
                    )}

                    {Object.keys(columns).map((columnName) => {
                      const isSelectColumn =
                        columns[columnName].type === "Select";
                      const columnAlignment =
                        columns[columnName].align || "left";
                      const columnWidth = columns[columnName].width;

                      return (
                        visibleColumns[columnName] &&
                        (item[columnName] !== null &&
                          item[columnName] !== undefined ? (
                          <td
                            className={`text-${columnAlignment || "center"
                              } text-truncate`}
                            onClick={() =>
                              setEditingIndex({
                                row: index,
                                column: columnName,
                              })
                            } // ✅ Track row and column
                            style={{
                              color:
                                columns[columnName].option?.find(
                                  (o) => o.value === Number(item[columnName])
                                )?.color || "inherit",
                              cursor: "pointer",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            {isSelectColumn ? (
                              editingIndex?.row === index &&
                                editingIndex?.column === columnName ? ( // ✅ Check if both row & column match
                                <Select
                                  name={columnName}
                                  isSearchable={false}
                                  components={{
                                    DropdownIndicator: () => null,
                                    IndicatorSeparator: () => null,
                                  }}
                                  onChange={(selectedOption) => {
                                    handleColumnSelect(
                                      selectedOption,
                                      item,
                                      columnName
                                    );

                                    setDropdownValue((prevState) => ({
                                      ...prevState,
                                      [item.LineNo]: {
                                        ...prevState[item.LineNo],
                                        [columnName]: selectedOption,
                                      },
                                    }));

                                    setEditingIndex(null); // Close dropdown on selection
                                  }}
                                  menuPortalTarget={document.body}
                                  styles={{
                                    control: (base) => ({
                                      ...base,
                                      width: "150px",
                                    }),
                                    menuPortal: (base) => ({
                                      ...base,
                                      zIndex: 9999,
                                    }),
                                  }}
                                  value={
                                    dropDownValue[item.LineNo]?.[columnName] ||
                                    columns[columnName].option?.find(
                                      (o) =>
                                        o.value === Number(item[columnName])
                                    ) || { value: null, label: "Select" }
                                  }
                                  options={[
                                    { value: null, label: "Select" },
                                    ...columns[columnName].option,
                                  ]}
                                  autoFocus
                                  onBlur={() => setEditingIndex(null)} // ✅ Close dropdown when it loses focus
                                />
                              ) : (
                                columns[columnName].option?.find(
                                  (o) => o.value === Number(item[columnName])
                                )?.label || "Select"
                              )
                            ) : (
                              item[columnName]
                            )}
                          </td>
                        ) : null)
                      );
                    })}
                    {isActionRequired && (
                      <td>
                        <div className="d-flex justify-content-center text-center">
                          {showIcon1 && (
                            <OverlayTrigger
                              placement="bottom"
                              overlay={
                                <Tooltip id="tooltip-bottom">
                                  {icons.Icon1Text || "Edit"}
                                </Tooltip>
                              }
                            >
                              <div
                                // className={`me-2 fw-bold disabled-icon${icons?.Icon1Flag && Array.isArray(icons.Icon1Flag) &&
                                //     icons.Icon1Flag.some(
                                //       (flag) => item[flag] === 0 || item[flag] === false
                                //     )
                                //     ? "disabled-icon"
                                //     : ""
                                //   }`}
                                className=" me-2 fw-bold disabled-icon"
                                onClick={() => {
                                  if (
                                    false
                                    // !icons?.Icon1Flag ||
                                    // !Array.isArray(icons.Icon1Flag) ||
                                    // !icons.Icon1Flag.some((flag) => item[flag] === 0 || item[flag] === false)
                                  ) {
                                    handleIcon1(item);
                                  }
                                }}
                              >
                                {icons.Icon1}
                              </div>
                            </OverlayTrigger>
                          )}

                          {showIcon2 && (
                            <OverlayTrigger
                              placement="bottom"
                              overlay={
                                <Tooltip id="tooltip-bottom">
                                  {icons.Icon2Text || "Edit"}
                                </Tooltip>
                              }
                            >
                              <div
                                // className='me-2'
                                // onClick={() => handleIcon2(item)}

                                // className={`me-2 ${
                                //   item[icons.Icon2Flag] === 0
                                //     ? "disabled-icon"
                                //     : ""
                                // }`}
                                className={`me-2 ${item[icons.Icon2Flag] === 0 ||
                                    item[icons.Icon2Flag] === false
                                    ? "disabled-icon"
                                    : ""
                                  }`}
                                // onClick={() => {
                                //   if (item[icons.Icon2Flag] !== 0)
                                //     handleIcon2(item);
                                // }}
                                onClick={() => {
                                  if (
                                    item[icons.Icon2Flag] !== 0 ||
                                    item[icons.Icon2Flag] !== false
                                  ) {
                                    handleIcon2(item);
                                  }
                                }}
                              >
                                {icons.Icon2}
                              </div>
                            </OverlayTrigger>
                          )}
                          {showIcon3 && (
                            <OverlayTrigger
                              placement="bottom"
                              overlay={
                                <Tooltip id="tooltip-bottom">
                                  {icons.Icon3Text}
                                </Tooltip>
                              }
                            >
                              <div
                                className={`me-2 ${item[icons.Icon3Flag] === 0
                                    ? "disabled-icon"
                                    : ""
                                  }`}
                                onClick={() => {
                                  if (item[icons.Icon3Flag] !== 0)
                                    handleIcon3(item);
                                }}
                              >
                                {icons.Icon3}
                              </div>
                            </OverlayTrigger>
                          )}
                          {showIcon4 && (
                            <OverlayTrigger
                              placement="bottom"
                              overlay={
                                <Tooltip id="tooltip-bottom">
                                  {icons.Icon4Text || "Add"}
                                </Tooltip>
                              }
                            >
                              <div
                                className={`me-2 ${item[icons.Icon4Flag] === 0
                                    ? "disabled-icon"
                                    : ""
                                  }`}
                                onClick={() => {
                                  if (item[icons.Icon4Flag] !== 0)
                                    handleIcon4(item);
                                }}
                              >
                                {icons.Icon4}
                              </div>
                            </OverlayTrigger>
                          )}
                          {showIcon5 && (
                            <OverlayTrigger
                              placement="bottom"
                              overlay={
                                <Tooltip id="tooltip-bottom">
                                  {icons.Icon5Text || "Add"}
                                </Tooltip>
                              }
                            >
                              <div
                                className={`me-2 ${item[icons.Icon5Flag] === 0
                                    ? "disabled-icon"
                                    : ""
                                  }`}
                                onClick={() => {
                                  if (item[icons.Icon5Flag] !== 0)
                                    handleIcon5(item);
                                }}
                              >
                                {icons.Icon5}
                              </div>
                            </OverlayTrigger>
                          )}
                        </div>
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>
            ) : (
              <tbody>
                <tr>
                  <td
                    colSpan={
                      Object.keys(columns).length +
                      (isCheckBoxRequired ? 1 : 0) +
                      (isActionRequired ? 1 : 0) +
                      (isSrNoRequired ? 1 : 0)
                    }
                    className="text-center"
                  >
                    <div>
                      <p>
                        <FaSpinner class="spinner" />
                        <br />
                        Loading
                      </p>
                    </div>
                  </td>
                </tr>
              </tbody>
            )}
          </Table>
        </div>
        {/* {filteredData.length > itemsPerPage && ( */}
        <div className="d-flex justify-content-between mb-3">
          <div>
            <span className="d-flex">
              Showing {(currentPage - 1) * selectedRecordsPerPage + 1} -{" "}
              {Math.min(
                currentPage * selectedRecordsPerPage,
                filteredData.length
              )}{" "}
              of {filteredData.length} <span className="ms-1">results</span>
              <select
                value={selectedRecordsPerPage}
                onChange={handleRecordsPerPage}
                className="mx-2 form-select-sm"
              >
                {recordsPerPageOption.map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </select>
            </span>
          </div>
          <div>
            <Pagination
              itemsPerPage={selectedRecordsPerPage}
              totalItems={filteredData.length}
              currentPage={currentPage}
              onPageChange={handlePageChange}
            />
          </div>
        </div>
        {/* )} */}
      </div>
    </div>
  );
};

export default AttendanceBookComponent;
